import { useWeb3React } from '@web3-react/core';

export const useSigner = () => {
  const { provider } = useWeb3React();

  return provider?.getSigner();
};
